import React, { useState } from "react";
import { Container } from "react-bootstrap";
import CommonBreadcrumb from "../common_components/breadcrumb/CommonBreadcrumb";
import TermConditionTab from "./terms_conditions_tab/TermConditionsTab";
import TermsConditionsContain from "./terms_conditions_contain/TermsConditionsContain";

const Cart = () => {
  const [activeTab, setActiveTab] = useState("1");

  const breadcrumbItems = [
    { label: "Home", link: "/home" },
    { label: "Terms & Conditions" },
  ];

  return (
    <section className="privacy-section terms-conditions-section">
      <div>
        <CommonBreadcrumb items={breadcrumbItems} />
      </div>
      <Container>
        <div className="privacy-wrapper">
          {/* Left Side */}
          <aside className="privacy-sidebar ">
            <div className="privacy-tab-sticky">
              <TermConditionTab
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>
          </aside>

          {/* Right Side */}
          <div className="privacy-content">
            <TermsConditionsContain activeTab={activeTab}/>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Cart;
